import React, { useEffect }  from "react";
import { Button, DatePicker, Drawer } from "rsuite";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  allAdmins,
  updateAdmin,
  resetAdmins,
  addAdmins,
  
} from "../../store/modules/admin/actions";
export default function AdminCarrosValidation() {
  const navigate = useNavigate();
  const { auth } = (state) => state.admin;
  const dispatch = useDispatch();
  const {
    reservations,
    reserva,
    carrosDisponivel,
    reservaCarrosCliente,
    components,
    behavior,
    form,
    vehicles,
    carro_Alugado
  } = useSelector((state) => state.admin);

  const setHorario = (key, value) => {
    dispatch(
      updateAdmin({
        reservations: { ...reservations, [key]: value },
      })
    );
  };
  const ChangeHorario = (key, value) => {
    dispatch(
      updateAdmin({
        carro_Alugado: { ...carro_Alugado, [key]: value },
      })
    );
  };
  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  function checarDatas() {
    var data_1 = reservations.start_date;
    var data_2 = reservations.end_date;
    if (data_1 > data_2) {
      alert("Data não pode ser maior que a data final");
      dispatch(resetAdmins());

      return false;
    } else {
      dispatch(allAdmins());
    }
  }

  const verCarro = (carro) => {
    dispatch(
      updateAdmin({
        behavior: "reservar",
      })
    );

    dispatch(
      updateAdmin({
        carro_Alugado: { ...carro[0] },
      })
    );

    setComponent("drawer", true);
  };

  const verReservaCarro = (carro) => {
    dispatch(
      updateAdmin({
        behavior: "reservado",
      })
    );

    dispatch(      
      updateAdmin({
        carro_Alugado: { ...carro },
      })
    );

    setComponent("drawer", true);
  };

  const setVehicle = (key, value) => {
    dispatch(
      updateAdmin({
        vehicles: { ...vehicles, [key]: value },
      })
    );
  };

  const salvarReserva = () => {
    dispatch(addAdmins());
  };

  const canselarReserva = () => {
    dispatch(canselarReserva());
  };

  useEffect(() => {
    checarDatas();
  }, [reservations.end_date]);

  function convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);

    var mySQLDate = [date.getFullYear(), month, day].join("-");
    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join("T");
  }

  return (
    <div className=" d-fex flex-column  col-12 col-sd-12 col-md-12 col-xl-12 p-0">
      <Drawer
        open={components.drawer}
        size="full"
        placement="top"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>
            {behavior === "reservar" ? "Reservar" : "Reservado"} Horarios{" "}
          
          </h3>

      {  carro_Alugado.users_id?
      <div>
        <b>
        {"Usuario_ID: "+  carro_Alugado.users_id}
       
        </b>
        
       
        
        <div className="d-flex flex-column col-12 col-sd-12 col-md-12 col-xl-12 ">
        <b>
      Data entrada e devolução: 
        
        </b>
          <DatePicker
        
            className="col-12 col-sd-12 col-md-12 col-xl-12 "
            ranges={[
              {
                label: "today",
                value: new Date(),
              },
            ]}
            format="dd-MM-yyyy HH:mm:ss"
            calendarDefaultDate={new Date()}
            color="orange"
            style={{ width: "auto" }}
            hideMinutes={(min) => ![0, 30].includes(min)}
            value= {new Date( carro_Alugado.start_date)}
            onChange={(e) => {
              ChangeHorario("start_date", convertDatePickerTimeToMySQLTime(e));
            }}
          />
          
          
         
          <DatePicker

            className="col-12 col-sd-12 col-md-12 col-xl-12 "
            ranges={[
              {
                label: "today",
                value: new Date(),
              },
            ]}
            format="dd-MM-yyyy HH:mm:ss"
            value= {new Date( carro_Alugado.end_date)}
            calendarDefaultDate={new Date()}
            color="orange"
            style={{ width: "auto" }}
            hideMinutes={(min) => ![0, 30].includes(min)}
            onChange={(e) => {
              ChangeHorario("end_date", convertDatePickerTimeToMySQLTime(e));
            }}
          />
          </div>

        <div className="form-group col-12 mt-2">
                <b className="">name</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.user.name}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Email</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.user.email}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Marca</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.vehicle.brand.name}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Modelo</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.vehicle.model}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Placa</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.vehicle.license}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Estado</b>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name"
                  disabled={form.disabled}
                  value={carro_Alugado.vehicle.status}                
                />
              </div>
        <div className="form-group col-12 mt-2">
                <b className="">Observação do cliente: </b>
               <p>
                {carro_Alugado.user_observations}
               </p>
              </div>

              <div className=" col-12 text-center size-sm mt-1 ">
                        <Button
                          appearance="primary"
                          color="green"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            navigate("/admin/checkout")
                          }}
                        >
                       
                          Check Out
                        </Button>
                        <Button
                          appearance="primary"
                          color="yellow"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            navigate("/admin/checkin")
                          }}
                        >
                       
                       Check In
                        </Button>
                        <Button
                          appearance="primary"
                          color="blue"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            setComponent("drawer", false);
                          }}
                        >
                       
                          Voltar
                        </Button>
                        </div> 
                        </div> :   <Button
                          appearance="primary"
                          color="blue"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            setComponent("drawer", false);
                          }}
                        >
                       
                          Voltar
                        </Button> }
        </Drawer.Body>
      </Drawer>
     
      <div className=" d-fex flex-column  col-12 col-sd-12 col-md-12 col-xl-12  p-0">
        
        <div className="d-flex flex-column col-12 col-sd-12 col-md-12 col-xl-12 ">
          <DatePicker
            className="col-12 col-sd-12 col-md-12 col-xl-12 m-1"
            ranges={[
              {
                label: "today",
                value: new Date(),
              },
            ]}
            format="dd-MM-yyyy HH:mm:ss"
            calendarDefaultDate={new Date()}
            color="orange"
            style={{ width: "auto" }}
            hideMinutes={(min) => ![0, 30].includes(min)}
            onChange={(e) => {
              setHorario("start_date", convertDatePickerTimeToMySQLTime(e));
            }}
          />

          <DatePicker
            className="col-12 col-sd-12 col-md-12 col-xl-12 m-1"
            ranges={[
              {
                label: "today",
                value: new Date(),
              },
            ]}
            format="dd-MM-yyyy HH:mm:ss"
            calendarDefaultDate={new Date()}
            style={{ width: "auto" }}
            hideMinutes={(min) => ![0, 30].includes(min)}
            onChange={(e) => {
              setHorario("end_date", convertDatePickerTimeToMySQLTime(e));
            }}
          />
        </div>

        <div className=" text-black card  block  p-0 text-center col-12 col-sd-12 col-md-12 col-xl-12  ">
          <b className=" p-0 col-12 col-sd-12 col-md-12 col-xl-12 text-center">
            Lista de carros
          </b>
          <div className="col-12 col-sd-12 col-md-12 col-xl-12 m-1 ">
    
            {reservations.length > 0 ? (
              reservations.map((carro) => { 
                return (
                   
                  <div className=" text-white   block  rounded bg-dark m-3 text-center">
                    <b className=" text-white   block  bg-dark m-1 text-center">
                      {carro[0].vehicle.brand.name}  
                    </b>
                    <b className=" text-white   block  bg-dark m-1 text-center">
                      {carro[0].vehicle.model}  
                    </b>
                    <b className=" text-white   block  bg-dark m-1 text-center">
                     Cliente:
                    </b>
                   
                    <b className=" text-white   block  bg-dark m-1 text-center">
                      { carro[0].user.name}  
                    </b>
                    <div className="d-flex flex-row text-center  justify-content-between ">
                    <p>
                    { carro[0].user_observations}  
                    </p>
                      <div className=" col-6 text-center size-sm ">
                        <Button
                          appearance="primary"
                          color="green"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            verCarro(carro);
                          }}
                        >
                          {" "}
                          Ver
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <h3>Escolha data de inicio e final</h3>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
